module.exports = __webpack_public_path__ + "img/docker.4f27b07a.png";